module.exports = __webpack_public_path__ + "static/img/4.d2173f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/3/zh/4.png
// module id = WecR
// module chunks = 0